export default __webpack_public_path__ + "static/media/sketch-korea-tn.01365fc6.png";